import React, { useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import { useLocation, useNavigate } from "react-router-dom";
import TopBar from "./components/TopNavbar";
import MarqueeBottom from "./components/MarqueeBottom";
import { useTheme } from "../context/ThemeContext";
import InPlayCom from "./components/InPlayCom";
import toast from "react-hot-toast";
import { BedSingle } from "lucide-react";
import LoginReg from "./LoginReg";
import { Spinner } from "react-bootstrap";

const formatDate = (date) => {
  const d = new Date(date); // Ensure it's a Date object

  if (isNaN(d.getTime())) {
    console.warn("Invalid date passed to formatDate:", date);
    return "";
  }

  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};


const compareWithToday = (openDate) => {
  const now = new Date();

  // Get today's date
  const today = formatDate(now);

  // Get tomorrow's date by adding 1 day to the current date
  const tomorrow = formatDate(new Date(now.getTime() + 24 * 60 * 60 * 1000)); // 24 hours in milliseconds

  // Convert openDate string to Date object
  const eventDateObj = new Date(openDate);

  const eventDateFormatted = formatDate(eventDateObj);

  return eventDateFormatted === today || eventDateFormatted === tomorrow;
};

const checkOpenDate = (openDate) => {
  // console.log('open',openDate);
  const currentTime = new Date();
  const eventDate = new Date(openDate);

  // Convert both times to IST
  const currentIST = new Date(currentTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  const eventIST = new Date(eventDate.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

  if (eventIST <= currentIST) {
    return "InPlay";
  }

  const isToday =
    currentIST.getFullYear() === eventIST.getFullYear() &&
    currentIST.getMonth() === eventIST.getMonth() &&
    currentIST.getDate() === eventIST.getDate();

  if (isToday) {
    return "Today";
  }
  // console.log('it is returning the data');
  // Else return formatted date
  return `${eventIST.getDate().toString().padStart(2, "0")}-${(eventIST.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${eventIST.getFullYear()}`;
};


export const InplayGames = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [oddsDelay, setOddsDelay] = useState();
  const [active, setActive] = useState(false);
  const [isSidebar, setSidebar] = useState(false);
  const [cricket, setCricket] = useState([]);
  const [soccer, setSoccer] = useState([]);
  const [tennis, setTennis] = useState([]);
  const [cric, setCric] = useState([]);
  const [socc, setSocc] = useState([]);
  const { themeColors } = useTheme();
  const [avail, setAvail] = useState([]);
  const [showCanvas, setShowCanvas] = useState(false);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(3);
  const [loading, setLoading] = useState(true);
  const [cricketRaw, setCricketRaw] = useState([]);
  const [soccerRaw, setSoccerRaw] = useState([]);
  const [tennisRaw, setTennisRaw] = useState([]);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);
  // const defaultGame = games.find((game) => game.name === 'All Games')?.name || games[1].name;
  const [selectedGame, setSelectedGame] = useState("All Games");
  const [fancyBetData, setFancyBetData] = useState([]);
  const [betData, setBetData] = useState([]);
  const [eventid, setEventid] = useState();
  const [eventname, setEventname] = useState()
  const [selectedMatch, setSelectedMatch] = useState('');
  const [selectionid, setSelectionid] = useState();
  const [runner, setRunner] = useState();
  const [competition, setCompetition] = useState();

  const [profit, setProfit] = useState(0);
  const [time, setTime] = useState();
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false); // NEW
  const [sportname, setSportname] = useState();
  const [loadingType, setLoadingType] = useState("");
  const [minOdds, setMinOdds] = useState(0);
  const [minBookmaker, setMinBookmaker] = useState(0);
  const [minMiniBook, setMinMiniBook] = useState(0);
  const [minFancy, setMinFancy] = useState(0);
  const [maxOdds, setMaxOdds] = useState(0);
  const [maxBookmaker, setMaxBookmaker] = useState(0);
  const [maxMiniBook, setMaxMiniBook] = useState(0);
  const [maxFancy, setMaxFancy] = useState(0);
  const [minNewDelay, setMinNewDelay] = useState();
  const location = useLocation();

  const [minBookDelay, setMinBookDelay] = useState();

  const [money, setMoney] = useState(0);
  const [pr, setPr] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [marketId, setMarketId] = useState(() => {
    return sessionStorage.getItem("marketId") || "";
  });


  const [rawMatches, setRawMatches] = useState([]);
  const [marketList, setMarketList] = useState([]);

  const sortMatches = (matches) => {
    return [...matches].sort((a, b) => {

      const aLive = a?.inplay || a?.event?.inPlay || a?.event?.status === "LIVE";
      const bLive = b?.inplay || b?.event?.inPlay || b?.event?.status === "LIVE";

      // 1️⃣ Live matches first
      if (aLive && !bLive) return -1;
      if (!aLive && bLive) return 1;

      // 2️⃣ Then by increasing start time
      const timeA = new Date(a?.event?.openDate).getTime();
      const timeB = new Date(b?.event?.openDate).getTime();

      return timeA - timeB;
    });
  };

  const [runner1, setRunner1] = useState(() => {
    return sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return sessionStorage.getItem("runner2") || "";
  });

  const [side, setSide] = useState('');
  const [selectedBet, setSelectedBet] = useState(0);






  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(6, 1fr)" : "repeat(12, 1fr)",
    gap: "5px",
  };


  const [formData, setFormData] = useState({
    competiton: '',
    eventname: '',
    eventid: 0,
    marketId: '',
    selectionId: 0,
    runnername: '',
    betPrice: 0,
    type: 'odds',
    betAmount: 0,
    profit: 0,
    side: '',
    status: 0,
    sportName: '',
    team1: runner1,
    team2: runner2,
    competitionId: "",
    selectedid2: 0,
  });
  // ✅ STEP 1A: matchData - setRawMatches instead of setCricket
  const matchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/matchapi", {
        headers: { "Content-Type": "application/json" },
      });
      // console.log("API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      console.log("Filtered Matches for Today:", allData);
      setCricketRaw(allData);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1B: footballData - setRawMatches instead of setCricket
  const footballData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/footballapi", {
        headers: { "Content-Type": "application/json" },
      });
      // console.log("Football API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      // console.log("Filtered Football Matches:", allData);
      setSoccerRaw(allData);
    } catch (error) {
      console.error("Football API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1C: tennisData - setRawMatches instead of setCricket
  const tennisData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + "/api/webapi/tennisapi", {
        headers: { "Content-Type": "application/json" },
      });
      // console.log("Tennis API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      // console.log("Filtered Tennis Matches:", allData);
      setTennisRaw(allData);
    } catch (error) {
      console.error("Tennis API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ define OUTSIDE
  const getMarkets = async (data, setter) => {
    setLoading(true)
    try {
      const eventIds = data.map(item => item?.event?.id);

      const res = await axios.post(`${base_url}/game/kheloyaar/getMarkets`, {
        eventIds
      });

      const sorted = sortMatches(res.data.data || []);
      setter(sorted);
    } catch (err) {
      console.error("Markets error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cricketRaw.length) getMarkets(cricketRaw, setCricket);
  }, [cricketRaw]);

  useEffect(() => {
    if (soccerRaw.length) getMarkets(soccerRaw, setSoccer);
  }, [soccerRaw]);

  useEffect(() => {
    if (tennisRaw.length) getMarkets(tennisRaw, setTennis);
  }, [tennisRaw]);

  useEffect(() => {
    const fetchOdds = async () => {
      setLoading(true)
      const allMarkets = [...cricket, ...soccer, ...tennis];

      if (allMarkets.length === 0) return;

      try {
        const marketIds = allMarkets
          .map(item => item.marketId)
          .filter(Boolean);

        const chunks = [];
        for (let i = 0; i < marketIds.length; i += 10) {
          chunks.push(marketIds.slice(i, i + 10));
        }

        const requests = chunks.map(chunk =>
          axios.post(`${base_url}/api/webapi/market/wholeMarket`, {
            marketIds: chunk
          })
        );

        const responses = await Promise.all(requests);

        let allOdds = [];

        responses.forEach(response => {
          const oddsData =
            typeof response.data === "string"
              ? JSON.parse(response.data)
              : response.data;

          const markets = oddsData?.data?.data || [];
          allOdds = [...allOdds, ...markets];
        });

        console.log("Fetched Odds Data:", allOdds);
        setAvail(allOdds);

      } catch (error) {
        console.error("Odds Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOdds();
  }, [cricket, soccer, tennis]); // ✅ IMPORTANT

  const oddsData1 = async (req, res) => {
    // console.log("Data is working ");
    let marketid = [];

    // console.log("Cricket dats in the odds are ", cricket);

    try {
      for (let item of cricket) {
        // console.log("items", item);
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setCric(result);
    } catch (err) {
      console.log(err);
    }
  };

  const oddsData2 = async (req, res) => {
    let marketid = [];

    try {
      for (let item of soccer) {
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setSocc(result);
    } catch (err) {
      console.log(err);
    }
  };

  const oddsData3 = async (req, res) => {
    let marketid = [];

    try {
      for (let item of tennis) {
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setAvail(result);
    } catch (err) {
      console.log(err);
    }
  };

  const odds = async () => {
    await oddsData1();
    await oddsData2();
    await oddsData3();
  };


  const betDataa = async () => {
    // Player-only endpoints (401 for a guest): skip them when logged out.
    if (!isAuthenticated) return;
    try {
      const response = await axios.get(
        base_url + "/api/webapi/betDataInplay",

        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log("databet", response);

      if (response?.data.success) {
        const sportsBets = response?.data.sportsBets;

        // console.log('ddd',data);
        setBetData(sportsBets);

      }
    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {



    betDataa();
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };




    handleResize();
    matchData();
    footballData();
    tennisData();


  }, []);

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([matchData(), footballData(), tennisData()]);
    };
    fetchAll();
  }, []);

  useEffect(() => {
    if (
      cricket.length > 0 &&
      soccer.length > 0 &&
      tennis.length > 0
    ) {
      odds();
    }
  }, [cricket, soccer, tennis]);


  // console.log('criket is devansh',cricket);
  // console.log('socc',soccer);
  // console.log('tenn',tennis);

  /* A price in the odds strip opens its match, where the bet slip is.
     The strip's own per-price handler (handleBetClick) is commented out,
     so these boxes used to do nothing. Empty "--" boxes stay inert. */
  const openFromOdds = (e, item) => {
    const box = e.target.closest(".odds-box");
    if (!box) return;
    const text = (box.textContent || "").trim();
    if (!text || /^-+$/.test(text.replace(/\s/g, ""))) return;
    handleClick(item);
  };

  /* TV / BM / F icons: shortcuts into the match page. On cricket the page
     scrolls to the BookMaker or Fancy section (Cricket.js reads rb_jump);
     the football and tennis pages have no such sections, so they just
     open the match. */
  const openMatchAt = (e, item, section) => {
    e.stopPropagation();
    if (item?.eventType?.name === "Cricket") {
      sessionStorage.setItem("rb_jump", section);
    }
    handleClick(item);
  };

  const handleClick = (item) => {
    // console.log(item);

    sessionStorage.setItem('marketId', item.marketId);
    sessionStorage.setItem('competetionid', item.competition.id);
    sessionStorage.setItem('eventid', item.event.id);
    sessionStorage.setItem('time', item?.event.openDate);
    sessionStorage.setItem('competitionname', item?.competition.name);
    sessionStorage.setItem('eventname', item?.event.name);

    if (item.eventType.name === "Cricket") {
      navigate('/cricketBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);


    } else if (item.eventType.name === "Football") {
      navigate('/footBAllBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);
      sessionStorage.setItem('selectionid3', item?.runners[2].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);
      sessionStorage.setItem('runner3', item.runners[2].runnerName);

    } else if (item.eventType.name === "Tennis") {
      navigate('/tennis');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);

    }


  }

  const handleSubmit = async () => {




    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if(isTenMinutesRemaining(time)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (money < 100) {
      toast.error("Bet cant be placed less than min value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    const delay = (parseFloat(oddsDelay || 0) + parseFloat(minNewDelay || 0)) * 1000;
    // console.log("delay is shnjdnkd", delay);

    // Show loading overlay
    // setIsLoading(true);
    // console.log("side bet delay", delay);
    // console.log("sidneis ", side);
    if (side === "Back") {
      setLoadingType("backodds");
      // console.log('Calleld is back ')
    } else {
      setLoadingType("layodds");
      // console.log('Calleld is lay')
    }

    // console.log("loading type is ", loadingType);
    // console.log('form',formData);
    setTimeout(async () => {
      try {
        const response = await axios.post(base_url + '/api/webapi/sportsData',
          formData,
          {
            withCredentials: true,
            headers: {
              'content-type': 'application/json',
            }
          }
        );

        console.log('formmatch', response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
          setbackActive(0);
          setlayActive(0);
        } else {
          toast.error(response?.data.message);
        }
        // window.location.reload();
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      } finally {
        // setIsLoading(false);
        setLoadingType("");

      }
      setLoadingType("");

    }, delay);

    setLoadingType("");
  };


  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };





  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };


  const handleBetClick = async (item, index, marketid) => {
    console.log("UI check", {
      backActive,
      layActive,
      side,
      selectedMatch,
      marketid
    });


    try {

      const allMatches = [...cricket, ...tennis, ...soccer]; // or whatever lists you're using
      const match = allMatches.find(m => m.marketId === marketid);
      const runners = match.runners;
      setEventid(match?.event.id);
      setEventname(match?.event.name);
      setCompetition(match?.competition.name);
      setSportname(match.eventType.name.toLowerCase());
      const time = formatDate(match?.openDate);
      setTime(time);
      // console.log(match);

      if (index < 2) {
        setSelectionid(runners[0].selectionId);
        setRunner(runners[0].runnerName);
      } else {
        setSelectionid(runners[1].selectionId);
        setRunner(runners[1].runnerName);
      }

      if (item?.type === 'Back') {
        // console.log('back called');
        setbackActive(1);
        setlayActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      }

      else if (item?.type === 'Lay') {
        // console.log('lay called');
        setlayActive(1);
        setbackActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      }

    } catch (err) {
      console.log(err);
    }
  }

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setRunner1(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner2(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setMarketId(location.state.runner2);
    }

    const proft =
      parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
    setProfit(proft.toFixed(1));

    // console.log('prff',proft);
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    handleResize();


    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);


  formData.competiton = competition;
  formData.eventid = eventid;
  formData.eventname = eventname;
  formData.marketId = selectedMatch;
  formData.selectionId = selectionid;
  formData.runnername = runner;
  formData.betPrice = selectedPrice;
  formData.betAmount = money;
  formData.side = side;
  formData.profit = profit;
  formData.sportName = sportname;


  const liveCricket = cricket?.filter(
    (item) =>
      checkOpenDate(item?.event.openDate) === "InPlay" && // ✅ Only "InPlay"
      cric[item.marketId] &&
      cric[item.marketId].length > 0 &&
      cric[item.marketId].some(
        (market) =>
          market?.ex?.availableToBack?.length > 0 ||
          market?.ex?.availableToLay?.length > 0
      )
  );


  const liveSoccer = soccer?.filter(
    (item) =>
      checkOpenDate(item?.event.openDate) === "InPlay" && // ✅ Only "InPlay"
      socc[item.marketId] &&
      socc[item.marketId].length > 0 &&
      socc[item.marketId].some(
        (market) =>
          market?.ex?.availableToBack?.length > 0 ||
          market?.ex?.availableToLay?.length > 0
      )
  );



  const liveTennis = tennis?.filter(
    (item) =>
      checkOpenDate(item?.event.openDate) === "InPlay" && // ✅ Only "InPlay"
      avail[item.marketId] &&
      avail[item.marketId].length > 0 &&
      avail[item.marketId].some(
        (market) =>
          market?.ex?.availableToBack?.length > 0 ||
          market?.ex?.availableToLay?.length > 0
      )
  );


  const matchCount = {
    'Cricket': liveCricket?.length || 0,
    'Soccer': liveSoccer?.length || 0,
    'Tennis': liveTennis?.length || 0,

  };

  return (
    <>
      <style>
        {`
      .details_small_blue_box{
        width: 50px;
      }
        .odds-box span{
        min-width: 50px;
        }
        .runnners-odds-details[_ngcontent-jrx-c94] .sport-name-wrapper[_ngcontent-jrx-c94] {
    flex: 1 1 48%;
}
      `}
      </style>


      {<LoginReg active={active} setactive={setActive} />}
      <app-root _nghost-jrx-c101="" ng-version="12.2.16">
        <div _ngcontent-jrx-c101="">
          <app-toasts
            _ngcontent-jrx-c101=""
            aria-live="polite"
            aria-atomic="true"
            className="ngb-toasts"
          ></app-toasts>
          <router-outlet _ngcontent-jrx-c101=""></router-outlet>
          <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
            <div _ngcontent-jrx-c95="" className="head-container">

              {/* {isLargeScreen && <TopBar />} */}
              <Header isSidebar={isSidebar} setSidebar={setSidebar} show={showCanvas} handleShow={handleCanvasShow} handleClose={handleCanvasClose} />

              <div _ngcontent-jrx-c95="" className="body-container mb-5">
                <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
                <div
                  _ngcontent-jrx-c95=""
                  className={`rightbar`}
                  style={{
                    paddingLeft: isLargeScreen ? "0px" : '0px',
                    paddingRight: isLargeScreen ? "3px" : '0px',
                    width: isSidebar ? "" : "2500%",
                    transition: "width 0.3s ease-in-out",
                    // backgroundColor: 'var(--dark-theme-data-bg)',
                  }}
                >

                  <div className="d-xl-flex gap-xl-1" style={{ paddingBottom: '3rem' }}>
                    <app-upcoming
                      _ngcontent-jrx-c95=""
                      _nghost-jrx-c94=""
                      className="ng-star-inserted"
                      style={{ width: isLargeScreen ? '75%' : '100%' }}
                    >
                      <InPlayCom selectedGame={selectedGame} setSelectedGame={setSelectedGame} matchCount={matchCount} />


                      {console.log(cricket, selectedGame, isLargeScreen, "kcnk")}

                      {(selectedGame === 'All Games' || selectedGame === 'Watch Live') && isLargeScreen && (
                        <div className="match-header d-flex flex-column mt-2 w-100">
                          <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                            <h6 className="my-0 fw-bold py-2 ps-2">Cricket</h6>
                          </div>
                          <div className="data_box_topRow mx-0 row p-1">
                            <div className="col-lg-9 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}></h6>
                            </div>
                            <div className="col-lg-3 mb-0">
                              <div className="row mb-0">
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>1</h6>
                                </div>
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>X</h6>
                                </div>
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>2</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                          {console.log(cricket, "n cc")}
                          {loading ? (
                            <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                              <Spinner animation="border" variant="primary" size="md" />
                              <p className="text-dark my-auto">Loading matches...</p>
                            </div>
                          ) : cricket.length ? (
                            cricket
                              .filter((item) => {

                                console.log(avail, "wcmw")
                                const market = avail.find(m => m.marketId === item.marketId);

                                return (
                                  market &&
                                  market.runners?.some(
                                    runner =>
                                      runner?.ex?.availableToBack?.length > 0 ||
                                      runner?.ex?.availableToLay?.length > 0
                                  )
                                );
                              }).map((item, index) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                const runner1 = market?.runners?.[0];
                                const runner2 = market?.runners?.[1];

                                const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                const marketData = market?.runners || [];
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-jrx-c94=""
                                    id={item?.competition?.id}
                                    className="flex-md-row justify-content-between ng-star-inserted"
                                    style={{ position: "relative" }}
                                  >
                                    <div>
                                      {/* <p>{item.marketId}</p> */}
                                      <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="section_details_box upcoming-data"
                                        >

                                          {item.isStarted && (
                                            <span
                                              _ngcontent-jrx-c94=""
                                              className="innerHTMLScore upcoming-score ng-star-inserted"
                                            >
                                              <div className="cricket-info">
                                                <div className="score"
                                                >
                                                  <span>
                                                    item2
                                                    <span className="vOver">(45.0)</span>
                                                  </span>
                                                  <span className="vRun">
                                                    0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                                  </span>
                                                  <span>
                                                    item
                                                    <span className="vOver">(0.0)</span>
                                                  </span>
                                                </div>
                                              </div>
                                            </span>
                                          )}

                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-type-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="runnners-odds-details"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-name-wrapper"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_box_team py-0 my-0"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_box_t_name d-flex t_left fs-4"
                                                    onClick={() => handleClick(item)}
                                                  >
                                                    <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz pe-1">{/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}Today</span>  <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className={`${new Date() >= new Date(item?.event.openDate)
                                                        ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                                        : ""
                                                        }`}
                                                    ></div>
                                                    {" "}
                                                    {item.runners[0].runnerName}{" "}
                                                    <span
                                                      _ngcontent-jrx-c94=""
                                                      className="vs ng-star-inserted"
                                                    >
                                                      {" "}
                                                      vs{" "}
                                                    </span>
                                                    {item.runners[1].runnerName}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="d-flex  p-0">
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="middle-detail"
                                                >
                                                  {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                  <img
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid ng-star-inserted"
                                                    style={{ height: "18px", width: "18px" }}
                                                    src="assets/images/tv (1).svg"
                                                    role="button"
                                                    title="Open match"
                                                    onClick={(e) => openMatchAt(e, item, "top")}
                                                    alt="TVKheloyaar360"
                                                  />

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid"
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                    </span>
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                    </span>
                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_odds_boxes_inn details_small_box_wrapper pt-1"
                                                  style={{ position: "relative", }}
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes"
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_small_boxes_let"
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes_inn ng-star-inserted"
                                                      >
                                                        {marketData &&
                                                          marketData.length > 0 && (
                                                            <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                              {(() => {
                                                                let backDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                  type: "Back",
                                                                }));

                                                                let layDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                  type: "Lay",
                                                                }));

                                                                while (
                                                                  backDivs.length <
                                                                  2
                                                                )
                                                                  backDivs.push({
                                                                    price: null,
                                                                    type: "Back",
                                                                  });
                                                                while (
                                                                  layDivs.length < 2
                                                                )
                                                                  layDivs.push({
                                                                    price: null,
                                                                    type: "Lay",
                                                                  });

                                                                let combinedDivs = [
                                                                  backDivs[0],
                                                                  layDivs[0],
                                                                  {
                                                                    price: null,
                                                                    type: "Back",
                                                                  },
                                                                  {
                                                                    price: null,
                                                                    type: "Lay",
                                                                  },
                                                                  backDivs[1],
                                                                  layDivs[1],
                                                                ];

                                                                return combinedDivs.map(
                                                                  (item, index) => (
                                                                    <app-oddsbutton
                                                                      key={index}
                                                                    >
                                                                      <div
                                                                        id={index}
                                                                        className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                      // onClick={() => handleBetClick(item, index, marketid)}
                                                                      >
                                                                        <span className="ng-star-inserted">
                                                                          {item.price !==
                                                                            null
                                                                            ? item.price
                                                                            : "--"}
                                                                        </span>
                                                                      </div>
                                                                    </app-oddsbutton>
                                                                  )
                                                                );
                                                              })()}
                                                            </div>
                                                          )}

                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      style={{ clear: "both" }}
                                                    ></div>
                                                  </div>
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* betting back div */}
                                    {/* {(backActive === 1 && side === 'Back' && selectedMatch === marketid) && (
                            <div style={{ backgroundColor: 'var(--dark-theme-data-homebet)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }} className="homebet">
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-backbtn)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >
                                  BACK
                                </button>
                                <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                  Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                  <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                </div>
                              </div>

                              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                <div className="w-25" style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      className="homebet_set"
                                      style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handlelayChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={selectedPrice}
                                      onChange={(e) => setSelectedPrice(e.target.value)}
                                      className="homebet_set"
                                      style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      className="homebet_set"
                                      style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handlelayChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                                <div className="w-25" style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      className="homebet_set"
                                      style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handleChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={money}
                                      onChange={(e) => setMoney(e.target.value)}
                                      className="homebet_set"
                                      style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      className="homebet_set"
                                      style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handleChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(100)}
                                >+ 100</button>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(200)}
                                >+ 200</button>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(500)}
                                >+ 500</button>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(1000)}
                                >+ 1k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(5000)}
                                >+ 5k</button>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(10000)}
                                >+ 10k</button>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(25000)}
                                >+ 25k</button>
                                <button
                                  className="homebet_set"
                                  style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(50000)}
                                >+ 50k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Clear</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Cancel</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => handleSubmit()}
                                >Submit</button>
                              </div>
                            </div>
                          )} */}



                                    {/* betting lay div */}
                                    {/* {(layActive === 1 && side === 'Lay' && selectedMatch === marketid) && (
                            <div style={{ backgroundColor: 'var(--dark-theme-data-homebet2)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }} className="homebet">
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >
                                  Lay
                                </button>
                                <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                  Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                  <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                </div>
                              </div>

                              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                <div style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handlelayChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={selectedPrice}
                                      onChange={(e) => setSelectedPrice(e.target.value)}
                                      style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handlelayChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handleChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={money}
                                      onChange={(e) => setMoney(e.target.value)}
                                      style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handleChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(100)}
                                >+ 100</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(200)}
                                >+ 200</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(500)}
                                >+ 500</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(1000)}
                                >+ 1k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(5000)}
                                >+ 5k</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(10000)}
                                >+ 10k</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(25000)}
                                >+ 25k</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(50000)}
                                >+ 50k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Clear</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setlayActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Cancel</button>
                                <button
                                  style={{ backgroundColor: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => handleSubmit()}
                                >Submit</button>
                              </div>
                            </div>
                          )} */}
                                  </div>
                                );
                              })
                          ) : (
                            <div className="text-dark">No Matches Found.</div>
                          )}





                          {/* <div>
                      <span className="bg-yellow px-4 py-1 w-25 rad bett">
                        Soccer
                      </span>
                    </div> */}
                          <div className="mt-2" style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                            <h6 className="my-0 fw-bold py-2 ps-2">Football</h6>
                          </div>
                          <div className="data_box_topRow mx-0 row p-1">
                            <div className="col-lg-9 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}></h6>
                            </div>
                            <div className="col-lg-3 mb-0">
                              <div className="row mb-0">
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>1</h6>
                                </div>
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>X</h6>
                                </div>
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>2</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                          {console.log(socc, "hhu")}

                          {loading ? (
                            <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                              <Spinner animation="border" variant="primary" size="md" />
                              <p className="text-dark my-auto">Loading matches...</p>
                            </div>
                          ) : soccer.length > 0 ? (
                            soccer
                              .filter((item) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                return (
                                  market &&
                                  market.runners?.some(
                                    runner =>
                                      runner?.ex?.availableToBack?.length > 0 ||
                                      runner?.ex?.availableToLay?.length > 0
                                  )
                                );
                              }).map((item, index) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                const runner1 = market?.runners?.[0];
                                const runner2 = market?.runners?.[1];

                                const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                const marketData = market?.runners || [];
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-jrx-c94=""
                                    id={item?.competition?.id}
                                    className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                    style={{ position: "relative" }}
                                  >
                                    <div >
                                      {/* <p>{item.marketId}</p> */}
                                      <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="section_details_box upcoming-data"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-type-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="runnners-odds-details"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-name-wrapper"
                                              >

                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_box_team"
                                                >

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_box_t_name d-flex t_left fs-4"
                                                    onClick={() => handleClick(item)}
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className={`${new Date() >= new Date(item?.event.openDate)
                                                        ? "green-circle inplay-blinker ng-star-inserted"
                                                        : ""
                                                        }`}
                                                    ></div>
                                                    {" "}
                                                    {item?.runners[0]?.runnerName}{" "}
                                                    <span
                                                      _ngcontent-jrx-c94=""
                                                      className="vs ng-star-inserted"
                                                    >
                                                      {" "}
                                                      vs{" "}
                                                    </span>
                                                    {item?.runners[1]?.runnerName}
                                                  </div>


                                                </div>
                                              </div>
                                              <div className="d-flex" style={{ marginTop: "2px", }}>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="middle-detail"
                                                >
                                                  {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                  <img
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid ng-star-inserted"
                                                    style={{ height: "18px", width: "18px" }}
                                                    src="assets/images/tv (1).svg"
                                                    role="button"
                                                    title="Open match"
                                                    onClick={(e) => openMatchAt(e, item, "top")}
                                                    alt="TVKheloyaar360"
                                                  />

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid"
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                    </span>
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                    </span>
                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                                  style={{ position: "relative", }}
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes"
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_small_boxes_let"
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes_inn ng-star-inserted"
                                                      >

                                                        {marketData &&
                                                          marketData.length > 0 && (
                                                            <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                              {(() => {
                                                                let backDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                  type: "Back",
                                                                }));

                                                                let layDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                  type: "Lay",
                                                                }));

                                                                while (
                                                                  backDivs.length <
                                                                  2
                                                                )
                                                                  backDivs.push({
                                                                    price: null,
                                                                    type: "Back",
                                                                  });
                                                                while (
                                                                  layDivs.length < 2
                                                                )
                                                                  layDivs.push({
                                                                    price: null,
                                                                    type: "Lay",
                                                                  });

                                                                let combinedDivs = [
                                                                  backDivs[0],
                                                                  layDivs[0],
                                                                  {
                                                                    price: null,
                                                                    type: "Back",
                                                                  },
                                                                  {
                                                                    price: null,
                                                                    type: "Lay",
                                                                  },
                                                                  backDivs[1],
                                                                  layDivs[1],
                                                                ];

                                                                return combinedDivs.map(
                                                                  (item, index) => (
                                                                    <app-oddsbutton
                                                                      key={index}
                                                                    >
                                                                      <div
                                                                        id={index}
                                                                        className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                      // onClick={() => handleBetClick(item, index, marketid)}
                                                                      >
                                                                        <span className="ng-star-inserted">
                                                                          {item.price !==
                                                                            null
                                                                            ? item.price
                                                                            : "--"}
                                                                        </span>
                                                                      </div>
                                                                    </app-oddsbutton>
                                                                  )
                                                                );
                                                              })()}
                                                            </div>
                                                          )}



                                                      </div>
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      style={{ clear: "both" }}
                                                    ></div>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ position: "relative" }}>
                                      {loadingType === "backodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}


                                    </div>


                                    <div style={{ position: "relative" }}>
                                      {loadingType === "layodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}
                                      {/* betting lay div */}

                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <div className="text-dark">No Playing Match.</div>
                          )}

                          {/* <div>
                      <span className="bg-yellow px-4 py-1 w-25 rad bett">
                        Tennis
                      </span>
                    </div> */}

                          <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                            <h6 className="my-0 fw-bold py-2 ps-2">Tennis</h6>
                          </div>
                          <div className="data_box_topRow mx-0 row p-1">
                            <div className="col-lg-9 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}></h6>
                            </div>
                            <div className="col-lg-3 mb-0">
                              <div className="row mb-0">
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>1</h6>
                                </div>
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>X</h6>
                                </div>
                                <div className="col-lg-4 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>2</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                          {loading ? (
                            <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                              <Spinner animation="border" variant="primary" size="md" />
                              <p className="text-dark my-auto">Loading matches...</p>
                            </div>
                          ) : tennis.length > 0 ? (
                            tennis
                              .filter((item) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                return (
                                  market &&
                                  market.runners?.some(
                                    runner =>
                                      runner?.ex?.availableToBack?.length > 0 ||
                                      runner?.ex?.availableToLay?.length > 0
                                  )
                                );
                              }).map((item, index) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                const runner1 = market?.runners?.[0];
                                const runner2 = market?.runners?.[1];

                                const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                const marketData = market?.runners || [];
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-jrx-c94=""
                                    // id={item?.competition?.id}
                                    className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                    style={{ position: "relative" }}
                                  >
                                    <div>
                                      {/* <p>{item.marketId}</p> */}
                                      <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="section_details_box upcoming-data"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-type-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="runnners-odds-details"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-name-wrapper"
                                              >

                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_box_team"
                                                >

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_box_t_name d-flex t_left fs-4"
                                                    onClick={() => handleClick(item)}
                                                  >

                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className={`${new Date() >= new Date(item?.event.openDate)
                                                        ? "green-circle inplay-blinker ng-star-inserted"
                                                        : ""
                                                        }`}
                                                    ></div>
                                                    {" "}
                                                    {item?.runners[0]?.runnerName}{" "}
                                                    <span
                                                      _ngcontent-jrx-c94=""
                                                      className="vs ng-star-inserted"
                                                    >
                                                      {" "}
                                                      vs{" "}
                                                    </span>
                                                    {item?.runners[1]?.runnerName}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="d-flex" style={{ marginTop: "2px", }}>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="middle-detail"
                                                >
                                                  {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                  <img
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid ng-star-inserted"
                                                    style={{ height: "18px", width: "18px" }}
                                                    src="assets/images/tv (1).svg"
                                                    role="button"
                                                    title="Open match"
                                                    onClick={(e) => openMatchAt(e, item, "top")}
                                                    alt="TVKheloyaar360"
                                                  />

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid"
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                    </span>
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                    </span>
                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                                  style={{ position: "relative", }}
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes"
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_small_boxes_let"
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes_inn ng-star-inserted"
                                                      >

                                                        {marketData &&
                                                          marketData.length > 0 && (
                                                            <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                              {(() => {
                                                                let backDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                  type: "Back",
                                                                }));

                                                                let layDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                  type: "Lay",
                                                                }));

                                                                while (
                                                                  backDivs.length <
                                                                  2
                                                                )
                                                                  backDivs.push({
                                                                    price: null,
                                                                    type: "Back",
                                                                  });
                                                                while (
                                                                  layDivs.length < 2
                                                                )
                                                                  layDivs.push({
                                                                    price: null,
                                                                    type: "Lay",
                                                                  });

                                                                let combinedDivs = [
                                                                  backDivs[0],
                                                                  layDivs[0],
                                                                  {
                                                                    price: null,
                                                                    type: "Back",
                                                                  },
                                                                  {
                                                                    price: null,
                                                                    type: "Lay",
                                                                  },
                                                                  backDivs[1],
                                                                  layDivs[1],
                                                                ];

                                                                return combinedDivs.map(
                                                                  (item, index) => (
                                                                    <app-oddsbutton
                                                                      key={index}
                                                                    >
                                                                      <div
                                                                        id={index}
                                                                        className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                      // onClick={() => handleBetClick(item, index, marketid)}
                                                                      >
                                                                        <span className="ng-star-inserted">
                                                                          {item.price !==
                                                                            null
                                                                            ? item.price
                                                                            : "--"}
                                                                        </span>
                                                                      </div>
                                                                    </app-oddsbutton>
                                                                  )
                                                                );
                                                              })()}
                                                            </div>
                                                          )}
                                                      </div>
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      style={{ clear: "both" }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ position: "relative" }}>
                                      {loadingType === "backodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}


                                    </div>


                                    <div style={{ position: "relative" }}>
                                      {loadingType === "layodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}

                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <div className="text-dark">No Matches Found.</div>
                          )}
                        </div>
                      )}

                      {(selectedGame === 'All Games' || selectedGame === 'Watch Live') && !isLargeScreen && (
                        <div className="match-header d-flex flex-column mt-2 pb-5 w-100">
                          <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                            <h6 className="my-0 fw-bold py-1 ps-2">Cricket</h6>
                          </div>
                          {loading ? (
                            <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                              <Spinner animation="border" variant="primary" size="md" />
                              <p className="text-dark my-auto">Loading matches...</p>
                            </div>
                          ) : cricket.length > 0 ? (
                            cricket
                              .filter((item) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                return (
                                  market &&
                                  market.runners?.some(
                                    runner =>
                                      runner?.ex?.availableToBack?.length > 0 ||
                                      runner?.ex?.availableToLay?.length > 0
                                  )
                                );
                              }).map((item, index) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                const runner1 = market?.runners?.[0];
                                const runner2 = market?.runners?.[1];

                                const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                const marketData = market?.runners || [];
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-jrx-c94=""
                                    id={item?.competition?.id}
                                    className="flex-md-row justify-content-between ng-star-inserted"
                                    style={{ position: "relative" }}
                                  >
                                    <div>
                                      {/* <p>{item.marketId}</p> */}
                                      <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="section_details_box upcoming-data"
                                        >

                                          {item.isStarted && (
                                            <span
                                              _ngcontent-jrx-c94=""
                                              className="innerHTMLScore upcoming-score ng-star-inserted"
                                            >
                                              <div className="cricket-info">
                                                <div className="score"
                                                >
                                                  <span>
                                                    item2
                                                    <span className="vOver">(45.0)</span>
                                                  </span>
                                                  <span className="vRun">
                                                    0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                                  </span>
                                                  <span>
                                                    item
                                                    <span className="vOver">(0.0)</span>
                                                  </span>
                                                </div>
                                              </div>
                                            </span>
                                          )}

                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-type-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="runnners-odds-details"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-name-wrapper"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_box_team py-0 my-0"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_box_t_name d-flex t_left fs-4"
                                                    onClick={() => handleClick(item)}
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className={`${new Date() >= new Date(item?.event.openDate)
                                                        ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                                        : ""
                                                        }`}
                                                    ></div>

                                                    {" "}
                                                    {item.runners[0].runnerName}{" "}
                                                    <span
                                                      _ngcontent-jrx-c94=""
                                                      className="vs ng-star-inserted"
                                                    >
                                                      {" "}
                                                      vs{" "}
                                                    </span>
                                                    {item.runners[1].runnerName}
                                                  </div>



                                                </div>
                                                <div className="d-flex">
                                                  <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz pe-1">{/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}Today</span>  <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1" style={{ color: 'var(--dark-theme-data-color)' }}>|</span>
                                                  <span style={{ color: 'var(--dark-theme-data-color)' }} className=" pe-1"> {item?.competitionName}</span>


                                                </div>

                                              </div>
                                              <div className="d-flex  p-0">
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="middle-detail"
                                                >
                                                  {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                  <img
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid ng-star-inserted"
                                                    style={{ height: "18px", width: "18px" }}
                                                    src="assets/images/tv (1).svg"
                                                    role="button"
                                                    title="Open match"
                                                    onClick={(e) => openMatchAt(e, item, "top")}
                                                    alt="TVKheloyaar360"
                                                  />

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid"
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                    </span>
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                    </span>
                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_odds_boxes_inn details_small_box_wrapper pt-1"
                                                  style={{ position: "relative", }}
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes"
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_small_boxes_let"
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes_inn ng-star-inserted"
                                                      >


                                                        {marketData &&
                                                          marketData.length > 0 && (
                                                            <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                              {(() => {
                                                                let backDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                  type: "Back",
                                                                }));

                                                                let layDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                  type: "Lay",
                                                                }));

                                                                while (
                                                                  backDivs.length <
                                                                  2
                                                                )
                                                                  backDivs.push({
                                                                    price: null,
                                                                    type: "Back",
                                                                  });
                                                                while (
                                                                  layDivs.length < 2
                                                                )
                                                                  layDivs.push({
                                                                    price: null,
                                                                    type: "Lay",
                                                                  });

                                                                let combinedDivs = [
                                                                  backDivs[0],
                                                                  layDivs[0],
                                                                  {
                                                                    price: null,
                                                                    type: "Back",
                                                                  },
                                                                  {
                                                                    price: null,
                                                                    type: "Lay",
                                                                  },
                                                                  backDivs[1],
                                                                  layDivs[1],
                                                                ];

                                                                return combinedDivs.map(
                                                                  (item, index) => (
                                                                    <app-oddsbutton
                                                                      key={index}
                                                                    >
                                                                      <div
                                                                        id={index}
                                                                        className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                      // onClick={() => handleBetClick(item, index, marketid)}
                                                                      >
                                                                        <span className="ng-star-inserted">
                                                                          {item.price !==
                                                                            null
                                                                            ? item.price
                                                                            : "--"}
                                                                        </span>
                                                                      </div>
                                                                    </app-oddsbutton>
                                                                  )
                                                                );
                                                              })()}
                                                            </div>
                                                          )}


                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      style={{ clear: "both" }}
                                                    ></div>
                                                  </div>
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* betting back div */}
                                    {(backActive === 1 && side === 'Back') && (
                                      <div style={{ backgroundColor: 'var(--dark-theme-data-homebet)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }} className="homebet">
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-backbtn)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                            onClick={() => {
                                              setbackActive(0);
                                              setMoney(0);
                                              setPr(0);
                                            }}
                                          >
                                            BACK
                                          </button>
                                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                          </div>
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                          </div>
                                        </div>

                                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                          <div className="w-25" style={{ flex: 1 }}>
                                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                            <div style={{ display: "flex", height: "40px" }}>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                onClick={() => handlelayChange(0)}
                                              >−</button>
                                              <input
                                                type="text"
                                                value={selectedPrice}
                                                onChange={(e) => setSelectedPrice(e.target.value)}
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                              />
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                onClick={() => handlelayChange(1)}
                                              >+</button>
                                            </div>
                                          </div>
                                          <div className="w-25" style={{ flex: 1 }}>
                                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                            <div style={{ display: "flex", height: "40px" }}>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                onClick={() => handleChange(0)}
                                              >−</button>
                                              <input
                                                type="text"
                                                value={money}
                                                onChange={(e) => setMoney(e.target.value)}
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                              />
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                onClick={() => handleChange(1)}
                                              >+</button>
                                            </div>
                                          </div>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(100)}
                                          >+ 100</button>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(200)}
                                          >+ 200</button>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(500)}
                                          >+ 500</button>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(1000)}
                                          >+ 1k</button>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(5000)}
                                          >+ 5k</button>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(10000)}
                                          >+ 10k</button>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(25000)}
                                          >+ 25k</button>
                                          <button
                                            className="homebet_set"
                                            style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(50000)}
                                          >+ 50k</button>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                          <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                          <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                          <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                            onClick={() => {
                                              setMoney(0);
                                              setPr(0);
                                            }}
                                          >Clear</button>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                            onClick={() => {
                                              setbackActive(0);
                                              setMoney(0);
                                              setPr(0);
                                            }}
                                          >Cancel</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                            onClick={() => handleSubmit()}
                                          >Submit</button>
                                        </div>
                                      </div>
                                    )}



                                    {/* betting lay div */}
                                    {(layActive === 1 && side === 'Lay') && (
                                      <div style={{ backgroundColor: 'var(--dark-theme-data-homebet2)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }} className="homebet">
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                            onClick={() => {
                                              setbackActive(0);
                                              setMoney(0);
                                              setPr(0);
                                            }}
                                          >
                                            Lay
                                          </button>
                                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                          </div>
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                          </div>
                                        </div>

                                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                          <div style={{ flex: 1 }}>
                                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                            <div style={{ display: "flex", height: "40px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                onClick={() => handlelayChange(0)}
                                              >−</button>
                                              <input
                                                type="text"
                                                value={selectedPrice}
                                                onChange={(e) => setSelectedPrice(e.target.value)}
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                              />
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                onClick={() => handlelayChange(1)}
                                              >+</button>
                                            </div>
                                          </div>
                                          <div style={{ flex: 1 }}>
                                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                            <div style={{ display: "flex", height: "40px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                onClick={() => handleChange(0)}
                                              >−</button>
                                              <input
                                                type="text"
                                                value={money}
                                                onChange={(e) => setMoney(e.target.value)}
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                              />
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                onClick={() => handleChange(1)}
                                              >+</button>
                                            </div>
                                          </div>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(100)}
                                          >+ 100</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(200)}
                                          >+ 200</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(500)}
                                          >+ 500</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(1000)}
                                          >+ 1k</button>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(5000)}
                                          >+ 5k</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(10000)}
                                          >+ 10k</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(25000)}
                                          >+ 25k</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                            onClick={() => setMoney(50000)}
                                          >+ 50k</button>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                          <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                          <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                          <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                            onClick={() => {
                                              setMoney(0);
                                              setPr(0);
                                            }}
                                          >Clear</button>
                                        </div>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                            onClick={() => {
                                              setlayActive(0);
                                              setMoney(0);
                                              setPr(0);
                                            }}
                                          >Cancel</button>
                                          <button
                                            style={{ backgroundColor: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                            onClick={() => handleSubmit()}
                                          >Submit</button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                          ) : (
                            <div className="text-dark">No Matches Found.</div>
                          )}

                          <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                            <h6 className="my-0 fw-bold py-1 ps-2">Football</h6>
                          </div>

                          {loading ? (
                            <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                              <Spinner animation="border" variant="primary" size="md" />
                              <p className="text-dark my-auto">Loading matches...</p>
                            </div>
                          ) : soccer.length > 0 ? (
                            soccer
                              .filter((item) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                return (
                                  market &&
                                  market.runners?.some(
                                    runner =>
                                      runner?.ex?.availableToBack?.length > 0 ||
                                      runner?.ex?.availableToLay?.length > 0
                                  )
                                );
                              }).map((item, index) => {
                                const market = avail.find(m => m.marketId === item.marketId);

                                const runner1 = market?.runners?.[0];
                                const runner2 = market?.runners?.[1];

                                const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                const marketData = market?.runners || [];
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-jrx-c94=""
                                    id={item?.competition?.id}
                                    className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                    style={{ position: "relative" }}
                                  >
                                    <div >
                                      {/* <p>{item.marketId}</p> */}
                                      <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="section_details_box upcoming-data"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-type-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="runnners-odds-details"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-name-wrapper"
                                              >

                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_box_team"
                                                >

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_box_t_name d-flex t_left fs-4"
                                                    onClick={() => handleClick(item)}
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className={`${new Date() >= new Date(item?.event.openDate)
                                                        ? "green-circle inplay-blinker ng-star-inserted"
                                                        : ""
                                                        }`}
                                                    ></div>
                                                    {" "}
                                                    {item?.runners[0]?.runnerName}{" "}
                                                    <span
                                                      _ngcontent-jrx-c94=""
                                                      className="vs ng-star-inserted"
                                                    >
                                                      {" "}
                                                      vs{" "}
                                                    </span>
                                                    {item?.runners[1]?.runnerName}
                                                  </div>




                                                </div>
                                                <div className="d-flex">
                                                  <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz pe-1">{/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}Today</span>  <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span>
                                                  <span>{item?.competitionName}</span>


                                                </div>
                                              </div>
                                              <div className="d-flex" style={{ marginTop: "2px", }}>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="middle-detail"
                                                >
                                                  {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                  <img
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid ng-star-inserted"
                                                    style={{ height: "18px", width: "18px" }}
                                                    src="assets/images/tv (1).svg"
                                                    role="button"
                                                    title="Open match"
                                                    onClick={(e) => openMatchAt(e, item, "top")}
                                                    alt="TVKheloyaar360"
                                                  />

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid"
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                    </span>
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                    </span>
                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                                  style={{ position: "relative", }}
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes"
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_small_boxes_let"
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes_inn ng-star-inserted"
                                                      >

                                                        {marketData &&
                                                          marketData.length > 0 && (
                                                            <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                              {(() => {
                                                                let backDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                  type: "Back",
                                                                }));

                                                                let layDivs = marketData.map((runner) => ({
                                                                  price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                  type: "Lay",
                                                                }));

                                                                while (
                                                                  backDivs.length <
                                                                  2
                                                                )
                                                                  backDivs.push({
                                                                    price: null,
                                                                    type: "Back",
                                                                  });
                                                                while (
                                                                  layDivs.length < 2
                                                                )
                                                                  layDivs.push({
                                                                    price: null,
                                                                    type: "Lay",
                                                                  });

                                                                let combinedDivs = [
                                                                  backDivs[0],
                                                                  layDivs[0],
                                                                  {
                                                                    price: null,
                                                                    type: "Back",
                                                                  },
                                                                  {
                                                                    price: null,
                                                                    type: "Lay",
                                                                  },
                                                                  backDivs[1],
                                                                  layDivs[1],
                                                                ];

                                                                return combinedDivs.map(
                                                                  (item, index) => (
                                                                    <app-oddsbutton
                                                                      key={index}
                                                                    >
                                                                      <div
                                                                        id={index}
                                                                        className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                      // onClick={() => handleBetClick(item, index, marketid)}
                                                                      >
                                                                        <span className="ng-star-inserted">
                                                                          {item.price !==
                                                                            null
                                                                            ? item.price
                                                                            : "--"}
                                                                        </span>
                                                                      </div>
                                                                    </app-oddsbutton>
                                                                  )
                                                                );
                                                              })()}
                                                            </div>
                                                          )}
                                                      </div>
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      style={{ clear: "both" }}
                                                    ></div>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ position: "relative" }}>
                                      {loadingType === "backodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}

                                      {(backActive === 1 && side === 'Back') && (
                                        <div
                                          style={{
                                            backgroundColor: 'var(--dark-theme-data-homebet)',
                                            padding: "5px",
                                            color: 'var(--dark-theme-color-navbar)',
                                            borderRadius: "5px",
                                            width: "100%",
                                          }}
                                        >
                                          {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-backbtn)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "end",
                                              gap: "10px",
                                              marginBottom: "7px",
                                            }}
                                          >
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handlelayChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={selectedPrice}
                                                  onChange={(e) =>
                                                    setSelectedPrice(e.target.value)
                                                  }
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handlelayChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handleChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={money}
                                                  onChange={(e) => setMoney(e.target.value)}
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handleChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            style={gridStyle}
                                          >
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(100)}
                                            >
                                              + 100
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(500)}
                                            >
                                              + 500
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(1000)}
                                            >
                                              + 1k
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(5000)}
                                            >
                                              + 5k
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(10000)}
                                            >
                                              + 10k
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(50000)}
                                            >
                                              + 50k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-cancel)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => {
                                                setbackActive(0);
                                                setMoney(0);
                                                setPr(0);
                                              }}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-submit)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => handleSubmit()}
                                            >
                                              Submit
                                            </button>
                                          </div>

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                        </div>
                                      )}
                                    </div>


                                    <div style={{ position: "relative" }}>
                                      {loadingType === "layodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}
                                      {/* betting lay div */}
                                      {(layActive === 1 && side === 'Lay') && (
                                        <div
                                          style={{
                                            backgroundColor: 'var(--dark-theme-data-homebet2)',
                                            padding: "5px",
                                            color: 'var(--dark-theme-color-navbar)',
                                            borderRadius: "5px",
                                            width: "100%",
                                          }}
                                        >
                                          {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "end",
                                              gap: "5px",
                                              marginBottom: "5px",
                                            }}
                                          >
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handlelayChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={selectedPrice}
                                                  onChange={(e) =>
                                                    setSelectedPrice(e.target.value)
                                                  }
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handlelayChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handleChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={money}
                                                  onChange={(e) => setMoney(e.target.value)}
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handleChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              display: "grid",
                                              gridTemplateColumns: "repeat(12, 1fr)",
                                              gap: "5px",
                                            }}
                                          >
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(100)}
                                            >
                                              + 100
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(500)}
                                            >
                                              + 500
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(1000)}
                                            >
                                              + 1k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(5000)}
                                            >
                                              + 5k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(10000)}
                                            >
                                              + 10k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(50000)}
                                            >
                                              + 50k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-submit)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => handleSubmit()}
                                            >
                                              Submit
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-cancel)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => {
                                                setlayActive(3);
                                                setMoney(0);
                                                setPr(0);
                                              }}
                                            >
                                              Cancel
                                            </button>
                                          </div>

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <div className="text-dark">No Playing Match.</div>
                          )}

                          <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                            <h6 className="my-0 fw-bold py-1 ps-2">Tennis</h6>
                          </div>

                          {loading ? (
                            <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                              <Spinner animation="border" variant="primary" size="md" />
                              <p className="text-dark my-auto">Loading matches...</p>
                            </div>
                          ) : tennis?.length > 0 ? (
                            tennis
                              ?.filter(
                                (item) =>
                                  checkOpenDate(item?.event.openDate) === "InPlay" && // ✅ Only "InPlay"
                                  avail[item.marketId] &&
                                  avail[item.marketId].length > 0 &&
                                  avail[item.marketId].some(
                                    (market) =>
                                      market?.ex?.availableToBack?.length > 0 ||
                                      market?.ex?.availableToLay?.length > 0
                                  )
                              )
                              .map((item, index) => {
                                const marketData = avail[item.marketId] || [];
                                const marketid = item.marketId;
                                console.log('marketdata', marketData);

                                if (!marketData) return null;
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-jrx-c94=""
                                    // id={item?.competition?.id}
                                    className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                    style={{ position: "relative" }}
                                  >
                                    <div>
                                      {/* <p>{item.marketId}</p> */}
                                      <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="section_details_box upcoming-data"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-type-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="runnners-odds-details"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-name-wrapper"
                                              >

                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_box_team"
                                                >

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_box_t_name d-flex t_left fs-4"
                                                    onClick={() => handleClick(item)}
                                                  >

                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className={`${new Date() >= new Date(item?.event.openDate)
                                                        ? "green-circle inplay-blinker ng-star-inserted"
                                                        : ""
                                                        }`}
                                                    ></div>
                                                    {" "}
                                                    {item?.runners[0]?.runnerName}{" "}
                                                    <span
                                                      _ngcontent-jrx-c94=""
                                                      className="vs ng-star-inserted"
                                                    >
                                                      {" "}
                                                      vs{" "}
                                                    </span>
                                                    {item?.runners[1]?.runnerName}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="d-flex" style={{ marginTop: "2px", }}>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="middle-detail"
                                                >
                                                  {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                  <img
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid ng-star-inserted"
                                                    style={{ height: "18px", width: "18px" }}
                                                    src="assets/images/tv (1).svg"
                                                    role="button"
                                                    title="Open match"
                                                    onClick={(e) => openMatchAt(e, item, "top")}
                                                    alt="TVKheloyaar360"
                                                  />

                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="small-grid"
                                                  >
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                    </span>
                                                    <span _ngcontent-jrx-c94="">
                                                      <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                    </span>
                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                                  style={{ position: "relative", }}
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes"
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_small_boxes_let"
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes_inn ng-star-inserted"
                                                      >

                                                        {marketData && marketData.length > 0 && (
                                                          <div className="d-flex runnners-odds-details gap-1" onClick={(e) => openFromOdds(e, item)}>
                                                            {(() => {
                                                              let backDivs = marketData.flatMap(market =>
                                                                market?.ex?.availableToBack?.length > 0
                                                                  ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                                  : []
                                                              );
                                                              let layDivs = marketData.flatMap(market =>
                                                                market?.ex?.availableToLay?.length > 0
                                                                  ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                                  : []
                                                              );

                                                              // Fill up with empty divs if needed to ensure 6 elements
                                                              while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                              while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                              let combinedDivs = [
                                                                backDivs[0],
                                                                layDivs[0],
                                                                { price: null, type: "Back" }, // Empty Back
                                                                { price: null, type: "Lay" }, // Empty Lay
                                                                backDivs[1],
                                                                layDivs[1],
                                                              ];

                                                              return combinedDivs.map((item, index) => (
                                                                <app-oddsbutton key={index}>
                                                                  <div
                                                                    id={index}
                                                                    className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                      } d-none d-sm-none details_small_blue_box odds-box `}
                                                                  //  onClick={()=>handleBetClick(item, index, marketid)}
                                                                  >
                                                                    <span className="ng-star-inserted">
                                                                      {item.price !== null ? item.price : "--"}
                                                                    </span>
                                                                  </div>
                                                                </app-oddsbutton>
                                                              ));
                                                            })()}
                                                          </div>
                                                        )}


                                                      </div>
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      style={{ clear: "both" }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ position: "relative" }}>
                                      {loadingType === "backodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}

                                      {(backActive === 1 && side === 'Back' && selectedMatch === marketid) && (
                                        <div
                                          style={{
                                            backgroundColor: 'var(--dark-theme-data-homebet)',
                                            padding: "5px",
                                            color: 'var(--dark-theme-color-navbar)',
                                            borderRadius: "5px",
                                            width: "100%",
                                          }}
                                        >
                                          {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-backbtn)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "end",
                                              gap: "10px",
                                              marginBottom: "7px",
                                            }}
                                          >
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handlelayChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={selectedPrice}
                                                  onChange={(e) =>
                                                    setSelectedPrice(e.target.value)
                                                  }
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handlelayChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handleChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={money}
                                                  onChange={(e) => setMoney(e.target.value)}
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handleChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            style={gridStyle}
                                          >
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(100)}
                                            >
                                              + 100
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(500)}
                                            >
                                              + 500
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(1000)}
                                            >
                                              + 1k
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(5000)}
                                            >
                                              + 5k
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(10000)}
                                            >
                                              + 10k
                                            </button>
                                            <button
                                              className="homebet_set"
                                              style={{
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "3px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(50000)}
                                            >
                                              + 50k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-cancel)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => {
                                                setbackActive(0);
                                                setMoney(0);
                                                setPr(0);
                                              }}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-submit)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => handleSubmit()}
                                            >
                                              Submit
                                            </button>
                                          </div>

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                        </div>
                                      )}
                                    </div>


                                    <div style={{ position: "relative" }}>
                                      {loadingType === "layodds" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 9999,
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          <img
                                            src="/assets/all_images/loadingimage/newpreloader.svg"
                                            alt="Loading..."
                                            style={{ width: "60px" }}
                                          />
                                        </div>
                                      )}
                                      {/* betting lay div */}
                                      {(layActive === 1 && side === 'Lay' && selectedMatch === marketid) && (
                                        <div
                                          style={{
                                            backgroundColor: 'var(--dark-theme-data-homebet2)',
                                            padding: "5px",
                                            color: 'var(--dark-theme-color-navbar)',
                                            borderRadius: "5px",
                                            width: "100%",
                                          }}
                                        >
                                          {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "end",
                                              gap: "5px",
                                              marginBottom: "5px",
                                            }}
                                          >
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handlelayChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={selectedPrice}
                                                  onChange={(e) =>
                                                    setSelectedPrice(e.target.value)
                                                  }
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handlelayChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                            <div>
                                              {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                              <div
                                                style={{ display: "flex", height: "30px" }}
                                              >
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "4px 0 0 4px",
                                                  }}
                                                  onClick={() => handleChange(0)}
                                                >
                                                  −
                                                </button>
                                                <input
                                                  type="text"
                                                  value={money}
                                                  onChange={(e) => setMoney(e.target.value)}
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-color-navbar)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    border: "none",
                                                    flex: 1,
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    width: "84px",
                                                  }}
                                                />
                                                <button
                                                  style={{
                                                    backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    width: "22px",
                                                    border: "none",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "0 4px 4px 0",
                                                  }}
                                                  onClick={() => handleChange(1)}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              display: "grid",
                                              gridTemplateColumns: "repeat(12, 1fr)",
                                              gap: "5px",
                                            }}
                                          >
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(100)}
                                            >
                                              + 100
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(500)}
                                            >
                                              + 500
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(1000)}
                                            >
                                              + 1k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(5000)}
                                            >
                                              + 5k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(10000)}
                                            >
                                              + 10k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-set2)',
                                                color: 'var(--dark-theme-white-color)',
                                                padding: "5px 0",
                                                fontSize: '12px',
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => setMoney(50000)}
                                            >
                                              + 50k
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-submit)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => handleSubmit()}
                                            >
                                              Submit
                                            </button>
                                            <button
                                              style={{
                                                background: 'var(--dark-theme-data-cancel)',
                                                color: 'var(--dark-theme-color-navbar)',
                                                padding: "5px 0",
                                                border: "none",
                                                borderRadius: "3px",
                                                fontWeight: "bold",
                                              }}
                                              onClick={() => {
                                                setlayActive(3);
                                                setMoney(0);
                                                setPr(0);
                                              }}
                                            >
                                              Cancel
                                            </button>
                                          </div>

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                          {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <div className="text-dark">No Matches Found.</div>
                          )}
                        </div>
                      )}

                      {isLargeScreen && (
                        <div className="match-header d-flex flex-column mt-2 w-100">
                          {selectedGame === 'Cricket' && (
                            <>
                              <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                                <h6 className="my-0 fw-bold py-1 ps-2">Cricket</h6>
                              </div>
                              <div className="data_box_topRow mx-0 row p-1">
                                <div className="col-lg-9 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}></h6>
                                </div>
                                <div className="col-lg-3 mb-0">
                                  <div className="row mb-0">
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>1</h6>
                                    </div>
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>X</h6>
                                    </div>
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>2</h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {loading ? (
                                <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                                  <Spinner animation="border" variant="primary" size="md" />
                                  <p className="text-dark my-auto">Loading matches...</p>
                                </div>
                              ) : cricket.length > 0 ? (
                                cricket
                                  .filter((item) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    return (
                                      market &&
                                      market.runners?.some(
                                        runner =>
                                          runner?.ex?.availableToBack?.length > 0 ||
                                          runner?.ex?.availableToLay?.length > 0
                                      )
                                    );
                                  }).map((item, index) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    const runner1 = market?.runners?.[0];
                                    const runner2 = market?.runners?.[1];

                                    const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                    const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                    const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                    const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                    const marketData = market?.runners || [];
                                    return (
                                      <div
                                        key={index}
                                        _ngcontent-jrx-c94=""
                                        id={item?.competition?.id}
                                        className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                        style={{ position: "relative" }}
                                      >
                                        <div >
                                          {/* <p>{item.marketId}</p> */}
                                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="section_details_box upcoming-data"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-type-detail"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="runnners-odds-details"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="sport-name-wrapper"
                                                  >

                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_box_team"
                                                    >

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_box_t_name d-flex t_left fs-4"
                                                        onClick={() => handleClick(item)}
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className={`${new Date() >= new Date(item?.event.openDate)
                                                            ? "green-circle inplay-blinker ng-star-inserted"
                                                            : ""
                                                            }`}
                                                        ></div>
                                                        {" "}
                                                        {item.runners[0].runnerName}{" "}
                                                        <span
                                                          _ngcontent-jrx-c94=""
                                                          className="vs ng-star-inserted"
                                                        >
                                                          {" "}
                                                          vs{" "}
                                                        </span>
                                                        {item.runners[1].runnerName}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="d-flex" style={{ marginTop: "2px", }}>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="middle-detail"
                                                    >
                                                      {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                      <img
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid ng-star-inserted"
                                                        style={{ height: "18px", width: "18px" }}
                                                        src="assets/images/tv (1).svg"
                                                        role="button"
                                                        title="Open match"
                                                        onClick={(e) => openMatchAt(e, item, "top")}
                                                        alt="TVKheloyaar360"
                                                      />

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid"
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                        </span>
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                        </span>
                                                      </div>

                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_odds_boxes_inn details_small_box_wrapper"
                                                      style={{ position: "relative", }}
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes"
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className="details_small_boxes_let"
                                                        >
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="details_small_boxes_inn ng-star-inserted"
                                                          >

                                                            {marketData &&
                                                              marketData.length > 0 && (
                                                                <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                                  {(() => {
                                                                    let backDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                      type: "Back",
                                                                    }));

                                                                    let layDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                      type: "Lay",
                                                                    }));

                                                                    while (
                                                                      backDivs.length <
                                                                      2
                                                                    )
                                                                      backDivs.push({
                                                                        price: null,
                                                                        type: "Back",
                                                                      });
                                                                    while (
                                                                      layDivs.length < 2
                                                                    )
                                                                      layDivs.push({
                                                                        price: null,
                                                                        type: "Lay",
                                                                      });

                                                                    let combinedDivs = [
                                                                      backDivs[0],
                                                                      layDivs[0],
                                                                      {
                                                                        price: null,
                                                                        type: "Back",
                                                                      },
                                                                      {
                                                                        price: null,
                                                                        type: "Lay",
                                                                      },
                                                                      backDivs[1],
                                                                      layDivs[1],
                                                                    ];

                                                                    return combinedDivs.map(
                                                                      (item, index) => (
                                                                        <app-oddsbutton
                                                                          key={index}
                                                                        >
                                                                          <div
                                                                            id={index}
                                                                            className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                                          >
                                                                            <span className="ng-star-inserted">
                                                                              {item.price !==
                                                                                null
                                                                                ? item.price
                                                                                : "--"}
                                                                            </span>
                                                                          </div>
                                                                        </app-oddsbutton>
                                                                      )
                                                                    );
                                                                  })()}
                                                                </div>
                                                              )}


                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          style={{ clear: "both" }}
                                                        ></div>
                                                      </div>
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                          {loadingType === "backodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}

                                          {(backActive === 1 && side === 'Back') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-backbtn)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "10px",
                                                  marginBottom: "7px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={gridStyle}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setbackActive(0);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>


                                        <div style={{ position: "relative" }}>
                                          {loadingType === "layodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}
                                          {/* betting lay div */}
                                          {(layActive === 1 && side === 'Lay') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet2)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns: "repeat(12, 1fr)",
                                                  gap: "5px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setlayActive(3);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                              ) : (
                                <div className="text-dark">No Matches Found.</div>
                              )}
                            </>
                          )}

                          {/* <div>
                      <span className="bg-yellow px-4 py-1 w-25 rad bett">
                        Soccer
                      </span>
                    </div> */}
                          {selectedGame === 'Football' && (
                            <>
                              <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                                <h6 className="my-0 fw-bold py-1 ps-2">Football</h6>
                              </div>
                              <div className="data_box_topRow mx-0 row p-1">
                                <div className="col-lg-9 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}></h6>
                                </div>
                                <div className="col-lg-3 mb-0">
                                  <div className="row mb-0">
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>1</h6>
                                    </div>
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>X</h6>
                                    </div>
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>2</h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {loading ? (
                                <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                                  <Spinner animation="border" variant="primary" size="md" />
                                  <p className="text-dark my-auto">Loading matches...</p>
                                </div>
                              ) : soccer.length > 0 ? (
                                soccer
                                  .filter((item) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    return (
                                      market &&
                                      market.runners?.some(
                                        runner =>
                                          runner?.ex?.availableToBack?.length > 0 ||
                                          runner?.ex?.availableToLay?.length > 0
                                      )
                                    );
                                  }).map((item, index) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    const runner1 = market?.runners?.[0];
                                    const runner2 = market?.runners?.[1];

                                    const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                    const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                    const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                    const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                    const marketData = market?.runners || [];
                                    return (
                                      <div
                                        key={index}
                                        _ngcontent-jrx-c94=""
                                        id={item?.competition?.id}
                                        className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                        style={{ position: "relative" }}
                                      >
                                        <div >
                                          {/* <p>{item.marketId}</p> */}
                                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="section_details_box upcoming-data"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-type-detail"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="runnners-odds-details"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="sport-name-wrapper"
                                                  >

                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_box_team"
                                                    >

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_box_t_name d-flex t_left fs-4"
                                                        onClick={() => handleClick(item)}
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className={`${new Date() >= new Date(item?.event.openDate)
                                                            ? "green-circle inplay-blinker ng-star-inserted"
                                                            : ""
                                                            }`}
                                                        ></div>
                                                        {" "}
                                                        {item?.runners[0]?.runnerName}{" "}
                                                        <span
                                                          _ngcontent-jrx-c94=""
                                                          className="vs ng-star-inserted"
                                                        >
                                                          {" "}
                                                          vs{" "}
                                                        </span>
                                                        {item?.runners[1]?.runnerName}
                                                      </div>

                                                    </div>
                                                  </div>
                                                  <div className="d-flex" style={{ marginTop: "2px", }}>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="middle-detail"
                                                    >
                                                      {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                      <img
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid ng-star-inserted"
                                                        style={{ height: "18px", width: "18px" }}
                                                        src="assets/images/tv (1).svg"
                                                        role="button"
                                                        title="Open match"
                                                        onClick={(e) => openMatchAt(e, item, "top")}
                                                        alt="TVKheloyaar360"
                                                      />

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid"
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                        </span>
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                        </span>
                                                      </div>

                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_odds_boxes_inn details_small_box_wrapper"
                                                      style={{ position: "relative", }}
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes"
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className="details_small_boxes_let"
                                                        >
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="details_small_boxes_inn ng-star-inserted"
                                                          >
                                                            {marketData &&
                                                              marketData.length > 0 && (
                                                                <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                                  {(() => {
                                                                    let backDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                      type: "Back",
                                                                    }));

                                                                    let layDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                      type: "Lay",
                                                                    }));

                                                                    while (
                                                                      backDivs.length <
                                                                      2
                                                                    )
                                                                      backDivs.push({
                                                                        price: null,
                                                                        type: "Back",
                                                                      });
                                                                    while (
                                                                      layDivs.length < 2
                                                                    )
                                                                      layDivs.push({
                                                                        price: null,
                                                                        type: "Lay",
                                                                      });

                                                                    let combinedDivs = [
                                                                      backDivs[0],
                                                                      layDivs[0],
                                                                      {
                                                                        price: null,
                                                                        type: "Back",
                                                                      },
                                                                      {
                                                                        price: null,
                                                                        type: "Lay",
                                                                      },
                                                                      backDivs[1],
                                                                      layDivs[1],
                                                                    ];

                                                                    return combinedDivs.map(
                                                                      (item, index) => (
                                                                        <app-oddsbutton
                                                                          key={index}
                                                                        >
                                                                          <div
                                                                            id={index}
                                                                            className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                                          >
                                                                            <span className="ng-star-inserted">
                                                                              {item.price !==
                                                                                null
                                                                                ? item.price
                                                                                : "--"}
                                                                            </span>
                                                                          </div>
                                                                        </app-oddsbutton>
                                                                      )
                                                                    );
                                                                  })()}
                                                                </div>
                                                              )}

                                                          </div>
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                          >
                                                            <span _ngcontent-jrx-c94="">
                                                              <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          style={{ clear: "both" }}
                                                        ></div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                          {loadingType === "backodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}

                                          {(backActive === 1 && side === 'Back') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-backbtn)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "10px",
                                                  marginBottom: "7px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={gridStyle}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setbackActive(0);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>


                                        <div style={{ position: "relative" }}>
                                          {loadingType === "layodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}
                                          {/* betting lay div */}
                                          {(layActive === 1 && side === 'Lay') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet2)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns: "repeat(12, 1fr)",
                                                  gap: "5px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setlayActive(3);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                              ) : (
                                <div className="text-dark">No Playing Match.</div>
                              )}
                            </>
                          )}

                          {/* <div>
                      <span className="bg-yellow px-4 py-1 w-25 rad bett">
                        Tennis
                      </span>
                    </div> */}

                          {selectedGame === 'Tennis' && (
                            <>
                              <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                                <h6 className="my-0 fw-bold py-1 ps-2">Tennis</h6>
                              </div>
                              <div className="data_box_topRow mx-0 row p-1">
                                <div className="col-lg-9 mb-0">
                                  <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}></h6>
                                </div>
                                <div className="col-lg-3 mb-0">
                                  <div className="row mb-0">
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>1</h6>
                                    </div>
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>X</h6>
                                    </div>
                                    <div className="col-lg-4 mb-0">
                                      <h6 className="my-0 fw-bold" style={{ color: 'var(--dark-theme-white-color)' }}>2</h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {loading ? (
                                <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                                  <Spinner animation="border" variant="primary" size="md" />
                                  <p className="text-dark my-auto">Loading matches...</p>
                                </div>
                              ) : tennis.length > 0 ? (
                                tennis
                                  .filter((item) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    return (
                                      market &&
                                      market.runners?.some(
                                        runner =>
                                          runner?.ex?.availableToBack?.length > 0 ||
                                          runner?.ex?.availableToLay?.length > 0
                                      )
                                    );
                                  }).map((item, index) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    const runner1 = market?.runners?.[0];
                                    const runner2 = market?.runners?.[1];

                                    const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                    const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                    const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                    const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                    const marketData = market?.runners || [];
                                    return (
                                      <div
                                        key={index}
                                        _ngcontent-jrx-c94=""
                                        id={item?.competition?.id}
                                        className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                        style={{ position: "relative" }}
                                      >
                                        <div>
                                          {/* <p>{item.marketId}</p> */}
                                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="section_details_box upcoming-data"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-type-detail"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="runnners-odds-details"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="sport-name-wrapper"
                                                  >

                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_box_team"
                                                    >

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_box_t_name d-flex t_left fs-4"
                                                        onClick={() => handleClick(item)}
                                                      >

                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className={`${new Date() >= new Date(item?.event.openDate)
                                                            ? "green-circle inplay-blinker ng-star-inserted"
                                                            : ""
                                                            }`}
                                                        ></div>
                                                        {" "}
                                                        {item.runners[0].runnerName}{" "}
                                                        <span
                                                          _ngcontent-jrx-c94=""
                                                          className="vs ng-star-inserted"
                                                        >
                                                          {" "}
                                                          vs{" "}
                                                        </span>
                                                        {item.runners[1].runnerName}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="d-flex" style={{ marginTop: "2px", }}>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="middle-detail"
                                                    >
                                                      {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                      <img
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid ng-star-inserted"
                                                        style={{ height: "18px", width: "18px" }}
                                                        src="assets/images/tv (1).svg"
                                                        role="button"
                                                        title="Open match"
                                                        onClick={(e) => openMatchAt(e, item, "top")}
                                                        alt="TVKheloyaar360"
                                                      />

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid"
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                        </span>
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                        </span>
                                                      </div>

                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_odds_boxes_inn details_small_box_wrapper"
                                                      style={{ position: "relative", }}
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes"
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className="details_small_boxes_let"
                                                        >
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="details_small_boxes_inn ng-star-inserted"
                                                          >

                                                            {marketData &&
                                                              marketData.length > 0 && (
                                                                <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                                  {(() => {
                                                                    let backDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                      type: "Back",
                                                                    }));

                                                                    let layDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                      type: "Lay",
                                                                    }));

                                                                    while (
                                                                      backDivs.length <
                                                                      2
                                                                    )
                                                                      backDivs.push({
                                                                        price: null,
                                                                        type: "Back",
                                                                      });
                                                                    while (
                                                                      layDivs.length < 2
                                                                    )
                                                                      layDivs.push({
                                                                        price: null,
                                                                        type: "Lay",
                                                                      });

                                                                    let combinedDivs = [
                                                                      backDivs[0],
                                                                      layDivs[0],
                                                                      {
                                                                        price: null,
                                                                        type: "Back",
                                                                      },
                                                                      {
                                                                        price: null,
                                                                        type: "Lay",
                                                                      },
                                                                      backDivs[1],
                                                                      layDivs[1],
                                                                    ];

                                                                    return combinedDivs.map(
                                                                      (item, index) => (
                                                                        <app-oddsbutton
                                                                          key={index}
                                                                        >
                                                                          <div
                                                                            id={index}
                                                                            className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                                          >
                                                                            <span className="ng-star-inserted">
                                                                              {item.price !==
                                                                                null
                                                                                ? item.price
                                                                                : "--"}
                                                                            </span>
                                                                          </div>
                                                                        </app-oddsbutton>
                                                                      )
                                                                    );
                                                                  })()}
                                                                </div>
                                                              )}
                                                          </div>
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                                          >
                                                            <span _ngcontent-jrx-c94="">
                                                              <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          style={{ clear: "both" }}
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                          {loadingType === "backodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}

                                          {(backActive === 1 && side === 'Back') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-backbtn)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "10px",
                                                  marginBottom: "7px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={gridStyle}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setbackActive(0);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>


                                        <div style={{ position: "relative" }}>
                                          {loadingType === "layodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}
                                          {/* betting lay div */}
                                          {(layActive === 1 && side === 'Lay') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet2)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns: "repeat(12, 1fr)",
                                                  gap: "5px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setlayActive(3);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                              ) : (
                                <div className="text-dark">No Matches Found.</div>
                              )}
                            </>
                          )}
                        </div>
                      )}

                      {!isLargeScreen && (
                        <div className="match-header d-flex flex-column mt-2 pb-5 w-100">
                          {selectedGame === 'Cricket' && (
                            <>
                              <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                                <h6 className="my-0 fw-bold py-1 ps-2">Cricket</h6>
                              </div>
                              {loading ? (
                                <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                                  <Spinner animation="border" variant="primary" size="md" />
                                  <p className="text-dark my-auto">Loading matches...</p>
                                </div>
                              ) : cricket.length > 0 ? (
                                cricket
                                  .filter((item) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    return (
                                      market &&
                                      market.runners?.some(
                                        runner =>
                                          runner?.ex?.availableToBack?.length > 0 ||
                                          runner?.ex?.availableToLay?.length > 0
                                      )
                                    );
                                  }).map((item, index) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    const runner1 = market?.runners?.[0];
                                    const runner2 = market?.runners?.[1];

                                    const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                    const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                    const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                    const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                    const marketData = market?.runners || [];
                                    return (
                                      <div
                                        key={index}
                                        _ngcontent-jrx-c94=""
                                        id={item?.competition?.id}
                                        className="flex-md-row justify-content-between ng-star-inserted"
                                        style={{ position: "relative" }}
                                      >
                                        <div>
                                          {/* <p>{item.marketId}</p> */}
                                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="section_details_box upcoming-data"
                                            >

                                              {item.isStarted && (
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="innerHTMLScore upcoming-score ng-star-inserted"
                                                >
                                                  <div className="cricket-info">
                                                    <div className="score"
                                                    >
                                                      <span>
                                                        item2
                                                        <span className="vOver">(45.0)</span>
                                                      </span>
                                                      <span className="vRun">
                                                        0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                                      </span>
                                                      <span>
                                                        item
                                                        <span className="vOver">(0.0)</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </span>
                                              )}

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-type-detail"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="runnners-odds-details"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="sport-name-wrapper"
                                                  >
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_box_team py-0 my-0"
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_box_t_name d-flex t_left fs-4"
                                                        onClick={() => handleClick(item)}
                                                      >
                                                        <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz pe-1">{/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}Today</span>  <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span>
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className={`${new Date() >= new Date(item?.event.openDate)
                                                            ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                                            : ""
                                                            }`}
                                                        ></div>
                                                        {" "}
                                                        {item.runners[0].runnerName}{" "}
                                                        <span
                                                          _ngcontent-jrx-c94=""
                                                          className="vs ng-star-inserted"
                                                        >
                                                          {" "}
                                                          vs{" "}
                                                        </span>
                                                        {item.runners[1].runnerName}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="d-flex  p-0">
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="middle-detail"
                                                    >
                                                      {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                      <img
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid ng-star-inserted"
                                                        style={{ height: "18px", width: "18px" }}
                                                        src="assets/images/tv (1).svg"
                                                        role="button"
                                                        title="Open match"
                                                        onClick={(e) => openMatchAt(e, item, "top")}
                                                        alt="TVKheloyaar360"
                                                      />

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid"
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                        </span>
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                        </span>
                                                      </div>

                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_odds_boxes_inn details_small_box_wrapper pt-1"
                                                      style={{ position: "relative", }}
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes"
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className="details_small_boxes_let"
                                                        >
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="details_small_boxes_inn ng-star-inserted"
                                                          >

                                                            {marketData &&
                                                              marketData.length > 0 && (
                                                                <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                                  {(() => {
                                                                    let backDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                      type: "Back",
                                                                    }));

                                                                    let layDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                      type: "Lay",
                                                                    }));

                                                                    while (
                                                                      backDivs.length <
                                                                      2
                                                                    )
                                                                      backDivs.push({
                                                                        price: null,
                                                                        type: "Back",
                                                                      });
                                                                    while (
                                                                      layDivs.length < 2
                                                                    )
                                                                      layDivs.push({
                                                                        price: null,
                                                                        type: "Lay",
                                                                      });

                                                                    let combinedDivs = [
                                                                      backDivs[0],
                                                                      layDivs[0],
                                                                      {
                                                                        price: null,
                                                                        type: "Back",
                                                                      },
                                                                      {
                                                                        price: null,
                                                                        type: "Lay",
                                                                      },
                                                                      backDivs[1],
                                                                      layDivs[1],
                                                                    ];

                                                                    return combinedDivs.map(
                                                                      (item, index) => (
                                                                        <app-oddsbutton
                                                                          key={index}
                                                                        >
                                                                          <div
                                                                            id={index}
                                                                            className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                                          >
                                                                            <span className="ng-star-inserted">
                                                                              {item.price !==
                                                                                null
                                                                                ? item.price
                                                                                : "--"}
                                                                            </span>
                                                                          </div>
                                                                        </app-oddsbutton>
                                                                      )
                                                                    );
                                                                  })()}
                                                                </div>
                                                              )}
                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          style={{ clear: "both" }}
                                                        ></div>
                                                      </div>
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* betting back div */}
                                        {(backActive === 1 && side === 'Back') && (
                                          <div style={{ backgroundColor: 'var(--dark-theme-data-homebet)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }} className="homebet">
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-backbtn)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setbackActive(0);
                                                  setMoney(0);
                                                  setPr(0);
                                                }}
                                              >
                                                BACK
                                              </button>
                                              <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                                Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                              </div>
                                              <div style={{ display: "flex", alignItems: "center" }}>
                                                <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                                <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                              </div>
                                            </div>

                                            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                              <div className="w-25" style={{ flex: 1 }}>
                                                <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                                <div style={{ display: "flex", height: "40px" }}>
                                                  <button
                                                    className="homebet_set"
                                                    style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                    onClick={() => handlelayChange(0)}
                                                  >−</button>
                                                  <input
                                                    type="text"
                                                    value={selectedPrice}
                                                    onChange={(e) => setSelectedPrice(e.target.value)}
                                                    className="homebet_set"
                                                    style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                                  />
                                                  <button
                                                    className="homebet_set"
                                                    style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                    onClick={() => handlelayChange(1)}
                                                  >+</button>
                                                </div>
                                              </div>
                                              <div className="w-25" style={{ flex: 1 }}>
                                                <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                                <div style={{ display: "flex", height: "40px" }}>
                                                  <button
                                                    className="homebet_set"
                                                    style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                    onClick={() => handleChange(0)}
                                                  >−</button>
                                                  <input
                                                    type="text"
                                                    value={money}
                                                    onChange={(e) => setMoney(e.target.value)}
                                                    className="homebet_set"
                                                    style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                                  />
                                                  <button
                                                    className="homebet_set"
                                                    style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                    onClick={() => handleChange(1)}
                                                  >+</button>
                                                </div>
                                              </div>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(100)}
                                              >+ 100</button>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(200)}
                                              >+ 200</button>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(500)}
                                              >+ 500</button>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(1000)}
                                              >+ 1k</button>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(5000)}
                                              >+ 5k</button>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(10000)}
                                              >+ 10k</button>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(25000)}
                                              >+ 25k</button>
                                              <button
                                                className="homebet_set"
                                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(50000)}
                                              >+ 50k</button>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                              <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                              <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                              <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setMoney(0);
                                                  setPr(0);
                                                }}
                                              >Clear</button>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setbackActive(0);
                                                  setMoney(0);
                                                  setPr(0);
                                                }}
                                              >Cancel</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => handleSubmit()}
                                              >Submit</button>
                                            </div>
                                          </div>
                                        )}



                                        {/* betting lay div */}
                                        {(layActive === 1 && side === 'Lay') && (
                                          <div style={{ backgroundColor: 'var(--dark-theme-data-homebet2)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }} className="homebet">
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setbackActive(0);
                                                  setMoney(0);
                                                  setPr(0);
                                                }}
                                              >
                                                Lay
                                              </button>
                                              <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                                Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                              </div>
                                              <div style={{ display: "flex", alignItems: "center" }}>
                                                <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                                <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                              </div>
                                            </div>

                                            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                              <div style={{ flex: 1 }}>
                                                <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                                <div style={{ display: "flex", height: "40px" }}>
                                                  <button
                                                    style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                    onClick={() => handlelayChange(0)}
                                                  >−</button>
                                                  <input
                                                    type="text"
                                                    value={selectedPrice}
                                                    onChange={(e) => setSelectedPrice(e.target.value)}
                                                    style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                                  />
                                                  <button
                                                    style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                    onClick={() => handlelayChange(1)}
                                                  >+</button>
                                                </div>
                                              </div>
                                              <div style={{ flex: 1 }}>
                                                <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                                <div style={{ display: "flex", height: "40px" }}>
                                                  <button
                                                    style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                                    onClick={() => handleChange(0)}
                                                  >−</button>
                                                  <input
                                                    type="text"
                                                    value={money}
                                                    onChange={(e) => setMoney(e.target.value)}
                                                    style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                                  />
                                                  <button
                                                    style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                                    onClick={() => handleChange(1)}
                                                  >+</button>
                                                </div>
                                              </div>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(100)}
                                              >+ 100</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(200)}
                                              >+ 200</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(500)}
                                              >+ 500</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(1000)}
                                              >+ 1k</button>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(5000)}
                                              >+ 5k</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(10000)}
                                              >+ 10k</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(25000)}
                                              >+ 25k</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                                onClick={() => setMoney(50000)}
                                              >+ 50k</button>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                              <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                              <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                              <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setMoney(0);
                                                  setPr(0);
                                                }}
                                              >Clear</button>
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setlayActive(0);
                                                  setMoney(0);
                                                  setPr(0);
                                                }}
                                              >Cancel</button>
                                              <button
                                                style={{ backgroundColor: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => handleSubmit()}
                                              >Submit</button>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })
                              ) : (
                                <div className="text-dark">No Matches Found.</div>
                              )}
                            </>
                          )}

                          {selectedGame === 'Football' && (
                            <>
                              <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                                <h6 className="my-0 fw-bold py-1 ps-2">Football</h6>
                              </div>
                              {loading ? (
                                <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                                  <Spinner animation="border" variant="primary" size="md" />
                                  <p className="text-dark my-auto">Loading matches...</p>
                                </div>
                              ) : soccer.length > 0 ? (
                                soccer
                                  .filter((item) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    return (
                                      market &&
                                      market.runners?.some(
                                        runner =>
                                          runner?.ex?.availableToBack?.length > 0 ||
                                          runner?.ex?.availableToLay?.length > 0
                                      )
                                    );
                                  }).map((item, index) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    const runner1 = market?.runners?.[0];
                                    const runner2 = market?.runners?.[1];

                                    const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                    const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                    const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                    const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                    const marketData = market?.runners || [];
                                    return (
                                      <div
                                        key={index}
                                        _ngcontent-jrx-c94=""
                                        id={item?.competition?.id}
                                        className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                        style={{ position: "relative" }}
                                      >
                                        <div >
                                          {/* <p>{item.marketId}</p> */}
                                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="section_details_box upcoming-data"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-type-detail"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="runnners-odds-details"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="sport-name-wrapper"
                                                  >

                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_box_team"
                                                    >

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_box_t_name d-flex t_left fs-4"
                                                        onClick={() => handleClick(item)}
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className={`${new Date() >= new Date(item?.event.openDate)
                                                            ? "green-circle inplay-blinker ng-star-inserted"
                                                            : ""
                                                            }`}
                                                        ></div>
                                                        {" "}
                                                        {item?.runners[0]?.runnerName}{" "}
                                                        <span
                                                          _ngcontent-jrx-c94=""
                                                          className="vs ng-star-inserted"
                                                        >
                                                          {" "}
                                                          vs{" "}
                                                        </span>
                                                        {item?.runners[1]?.runnerName}
                                                      </div>

                                                    </div>
                                                  </div>
                                                  <div className="d-flex" style={{ marginTop: "2px", }}>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="middle-detail"
                                                    >
                                                      {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                      <img
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid ng-star-inserted"
                                                        style={{ height: "18px", width: "18px" }}
                                                        src="assets/images/tv (1).svg"
                                                        role="button"
                                                        title="Open match"
                                                        onClick={(e) => openMatchAt(e, item, "top")}
                                                        alt="TVKheloyaar360"
                                                      />

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid"
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                        </span>
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                        </span>
                                                      </div>

                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_odds_boxes_inn details_small_box_wrapper"
                                                      style={{ position: "relative", }}
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes"
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className="details_small_boxes_let"
                                                        >
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="details_small_boxes_inn ng-star-inserted"
                                                          >

                                                            {marketData &&
                                                              marketData.length > 0 && (
                                                                <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                                  {(() => {
                                                                    let backDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                      type: "Back",
                                                                    }));

                                                                    let layDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                      type: "Lay",
                                                                    }));

                                                                    while (
                                                                      backDivs.length <
                                                                      2
                                                                    )
                                                                      backDivs.push({
                                                                        price: null,
                                                                        type: "Back",
                                                                      });
                                                                    while (
                                                                      layDivs.length < 2
                                                                    )
                                                                      layDivs.push({
                                                                        price: null,
                                                                        type: "Lay",
                                                                      });

                                                                    let combinedDivs = [
                                                                      backDivs[0],
                                                                      layDivs[0],
                                                                      {
                                                                        price: null,
                                                                        type: "Back",
                                                                      },
                                                                      {
                                                                        price: null,
                                                                        type: "Lay",
                                                                      },
                                                                      backDivs[1],
                                                                      layDivs[1],
                                                                    ];

                                                                    return combinedDivs.map(
                                                                      (item, index) => (
                                                                        <app-oddsbutton
                                                                          key={index}
                                                                        >
                                                                          <div
                                                                            id={index}
                                                                            className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                                          >
                                                                            <span className="ng-star-inserted">
                                                                              {item.price !==
                                                                                null
                                                                                ? item.price
                                                                                : "--"}
                                                                            </span>
                                                                          </div>
                                                                        </app-oddsbutton>
                                                                      )
                                                                    );
                                                                  })()}
                                                                </div>
                                                              )}
                                                          </div>
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="pin_icon" style={{ border: "1px solid grey", height: "21px", width: "21px" }}
                                                          >
                                                            <span _ngcontent-jrx-c94="">
                                                              <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          style={{ clear: "both" }}
                                                        ></div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                          {loadingType === "backodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}

                                          {(backActive === 1 && side === 'Back') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-backbtn)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "10px",
                                                  marginBottom: "7px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={gridStyle}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setbackActive(0);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>


                                        <div style={{ position: "relative" }}>
                                          {loadingType === "layodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}
                                          {/* betting lay div */}
                                          {(layActive === 1 && side === 'Lay') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet2)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns: "repeat(12, 1fr)",
                                                  gap: "5px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setlayActive(3);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                              ) : (
                                <div className="text-dark">No Playing Match.</div>
                              )}
                            </>
                          )}

                          {selectedGame === 'Tennis' && (
                            <>
                              <div style={{ backgroundColor: 'var(--dark-theme-time-remaining)' }}>
                                <h6 className="my-0 fw-bold py-1 ps-2">Tennis</h6>
                              </div>


                              {loading ? (
                                <div className="d-flex justify-content-center gap-3" style={{ textAlign: "center", padding: "10px" }}>
                                  <Spinner animation="border" variant="primary" size="md" />
                                  <p className="text-dark my-auto">Loading matches...</p>
                                </div>
                              ) : tennis.length > 0 ? (
                                tennis
                                  .filter((item) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    return (
                                      market &&
                                      market.runners?.some(
                                        runner =>
                                          runner?.ex?.availableToBack?.length > 0 ||
                                          runner?.ex?.availableToLay?.length > 0
                                      )
                                    );
                                  }).map((item, index) => {
                                    const market = avail.find(m => m.marketId === item.marketId);

                                    const runner1 = market?.runners?.[0];
                                    const runner2 = market?.runners?.[1];

                                    const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                                    const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                                    const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                                    const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                                    const marketData = market?.runners || [];
                                    return (
                                      <div
                                        key={index}
                                        _ngcontent-jrx-c94=""
                                        // id={item?.competition?.id}
                                        className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                        style={{ position: "relative" }}
                                      >
                                        <div>
                                          {/* <p>{item.marketId}</p> */}
                                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="section_details_box upcoming-data"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="sport-type-detail"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="runnners-odds-details"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="sport-name-wrapper"
                                                  >

                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_box_team"
                                                    >

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_box_t_name d-flex t_left fs-4"
                                                        onClick={() => handleClick(item)}
                                                      >

                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className={`${new Date() >= new Date(item?.event.openDate)
                                                            ? "green-circle inplay-blinker ng-star-inserted"
                                                            : ""
                                                            }`}
                                                        ></div>
                                                        {" "}
                                                        {item?.runners[0]?.runnerName}{" "}
                                                        <span
                                                          _ngcontent-jrx-c94=""
                                                          className="vs ng-star-inserted"
                                                        >
                                                          {" "}
                                                          vs{" "}
                                                        </span>
                                                        {item?.runners[1]?.runnerName}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="d-flex" style={{ marginTop: "2px", }}>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="middle-detail"
                                                    >
                                                      {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                                      <img
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid ng-star-inserted"
                                                        style={{ height: "18px", width: "18px" }}
                                                        src="assets/images/tv (1).svg"
                                                        role="button"
                                                        title="Open match"
                                                        onClick={(e) => openMatchAt(e, item, "top")}
                                                        alt="TVKheloyaar360"
                                                      />

                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="small-grid"
                                                      >
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid rb-inplay-shortcut" src="/assets/images/bm-icon1.svg" alt="BookMaker" title="BookMaker markets" role="button" onClick={(e) => openMatchAt(e, item, "bookmaker")} />
                                                        </span>
                                                        <span _ngcontent-jrx-c94="">
                                                          <img className="imgfluid ms-1 rb-inplay-shortcut" src="/assets/images/fancy-icon1.svg" alt="Fancy" title="Fancy markets" role="button" onClick={(e) => openMatchAt(e, item, "fancy")} />
                                                        </span>
                                                      </div>

                                                    </div>
                                                    <div
                                                      _ngcontent-jrx-c94=""
                                                      className="details_odds_boxes_inn details_small_box_wrapper"
                                                      style={{ position: "relative", }}
                                                    >
                                                      <div
                                                        _ngcontent-jrx-c94=""
                                                        className="details_small_boxes"
                                                      >
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          className="details_small_boxes_let"
                                                        >
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="details_small_boxes_inn ng-star-inserted"
                                                          >

                                                            {marketData &&
                                                              marketData.length > 0 && (
                                                                <div className="d-flex runnners-odds-details" onClick={(e) => openFromOdds(e, item)}>
                                                                  {(() => {
                                                                    let backDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToBack?.[0]?.price || null,
                                                                      type: "Back",
                                                                    }));

                                                                    let layDivs = marketData.map((runner) => ({
                                                                      price: runner?.ex?.availableToLay?.[0]?.price || null,
                                                                      type: "Lay",
                                                                    }));

                                                                    while (
                                                                      backDivs.length <
                                                                      2
                                                                    )
                                                                      backDivs.push({
                                                                        price: null,
                                                                        type: "Back",
                                                                      });
                                                                    while (
                                                                      layDivs.length < 2
                                                                    )
                                                                      layDivs.push({
                                                                        price: null,
                                                                        type: "Lay",
                                                                      });

                                                                    let combinedDivs = [
                                                                      backDivs[0],
                                                                      layDivs[0],
                                                                      {
                                                                        price: null,
                                                                        type: "Back",
                                                                      },
                                                                      {
                                                                        price: null,
                                                                        type: "Lay",
                                                                      },
                                                                      backDivs[1],
                                                                      layDivs[1],
                                                                    ];

                                                                    return combinedDivs.map(
                                                                      (item, index) => (
                                                                        <app-oddsbutton
                                                                          key={index}
                                                                        >
                                                                          <div
                                                                            id={index}
                                                                            className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}

                                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                                          >
                                                                            <span className="ng-star-inserted">
                                                                              {item.price !==
                                                                                null
                                                                                ? item.price
                                                                                : "--"}
                                                                            </span>
                                                                          </div>
                                                                        </app-oddsbutton>
                                                                      )
                                                                    );
                                                                  })()}
                                                                </div>
                                                              )}


                                                          </div>
                                                          <div
                                                            _ngcontent-jrx-c94=""
                                                            className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                                          >
                                                            <span _ngcontent-jrx-c94="">
                                                              <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          _ngcontent-jrx-c94=""
                                                          style={{ clear: "both" }}
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                          {loadingType === "backodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgb(51, 192, 243), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}

                                          {(backActive === 1 && side === 'Back') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-backbtn)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "10px",
                                                  marginBottom: "7px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={gridStyle}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="homebet_set"
                                                  style={{
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "3px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setbackActive(0);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>


                                        <div style={{ position: "relative" }}>
                                          {loadingType === "layodds" && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                zIndex: 9999,
                                                width: "100%",
                                                height: "100%",
                                                background:
                                                  "linear-gradient(135deg, rgba(51, 192, 243, 0.78), rgba(200, 47, 151, 0.76))",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              <img
                                                src="/assets/all_images/loadingimage/newpreloader.svg"
                                                alt="Loading..."
                                                style={{ width: "60px" }}
                                              />
                                            </div>
                                          )}
                                          {/* betting lay div */}
                                          {(layActive === 1 && side === 'Lay') && (
                                            <div
                                              style={{
                                                backgroundColor: 'var(--dark-theme-data-homebet2)',
                                                padding: "5px",
                                                color: 'var(--dark-theme-color-navbar)',
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handlelayChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedPrice}
                                                      onChange={(e) =>
                                                        setSelectedPrice(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handlelayChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                                <div>
                                                  {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                                  <div
                                                    style={{ display: "flex", height: "30px" }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "4px 0 0 4px",
                                                      }}
                                                      onClick={() => handleChange(0)}
                                                    >
                                                      −
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={money}
                                                      onChange={(e) => setMoney(e.target.value)}
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-color-navbar)',
                                                        color: 'var(--dark-theme-white-color)',
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                        width: "84px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                                        color: 'var(--dark-theme-color-navbar)',
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0 4px 4px 0",
                                                      }}
                                                      onClick={() => handleChange(1)}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns: "repeat(12, 1fr)",
                                                  gap: "5px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(100)}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(500)}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(1000)}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(5000)}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(10000)}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-set2)',
                                                    color: 'var(--dark-theme-white-color)',
                                                    padding: "5px 0",
                                                    fontSize: '12px',
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => setMoney(50000)}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-submit)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => handleSubmit()}
                                                >
                                                  Submit
                                                </button>
                                                <button
                                                  style={{
                                                    background: 'var(--dark-theme-data-cancel)',
                                                    color: 'var(--dark-theme-color-navbar)',
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setlayActive(3);
                                                    setMoney(0);
                                                    setPr(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                              </div>

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                                              {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                              ) : (
                                <div className="text-dark">No Matches Found.</div>
                              )}
                            </>
                          )}
                        </div>
                      )}


                    </app-upcoming>

                    {/* <div
                  className=" mt-3 mt-lg-0 ms-0 ms-lg-1 mb-4 h-100 pr-1 bg-white"
                  style={{
                    maxHeight: "100vh",
                    minHeight: "100vh",
                    // height: `${betData.length * 6}vh`,
                  }}
                >
                  <div
                    className="m-0 px-2 py-1 bett w-100"
                    style={{
                      background:
                        'var(--dark-theme-bg)',
                      color: 'var(--dark-theme-data-bg)',
                    }}
                  >
                    My Bets
                  </div>
                  <table
                    className="border  w-100"
                    style={{ borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr className="text-black">
                        <th className="headerColor">Runner Name</th>
                        <th>ODDS</th>
                        <th>Bet Amount</th>
                        <th>Side</th>
                        <th>P/L</th>
                      </tr>
                    </thead>

                    <tbody>
                      {betData?.length > 0 ? (
                        <>
                          <tr>
                            <th
                              colSpan={5}
                              style={{
                                background: "#000",
                                color: "#fff",
                              }}
                            >
                              Sports Bets
                            </th>
                          </tr>
                          {betData.map((bet, index) => (
                            <tr key={`sports-${index}`} style={{
                                    backgroundColor: bet?.side === "Back"
                                      ? "var(--dark-theme-data-box)"
                                      : "#faa9ba", color: "black"
                                  }}>
                              <td>
                                {bet.runnerName} ({bet.type})
                              </td>
                              <td>{bet.betprice}</td>
                              <td>{bet.betAmount}</td>
                               <td>{bet.side}</td>
                              <td>{bet.profit}</td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td
                            colSpan={4}
                            style={{ color: 'var(--dark-theme-demoaccount)', textAlign: "center" }}
                          >
                            No sports bet data
                          </td>
                        </tr>
                      )}

                   
                    </tbody>
                  </table>
                </div> */}
                  </div>

                  {/* <Footer /> */}
                </div>
              </div>
              <MarqueeBottom onMenuClick={handleCanvasShow} />
            </div >
          </app-landing-page-new>
        </div >
      </app-root >
    </>
  );
};
export default InplayGames;
